module.exports = __webpack_public_path__ + "static/media/emoticon-emotion-expression-feeling-happy-svgrepo-com.1431f980.svg";